import { addOrUpdateManagementReport } from './helpers'
import { EmptyManagementReport, ManagementReport } from './types'
import { ManagementReportAction } from './actions'

export interface State {
  managementReports: Record<string, ManagementReport>
  pending: boolean
  error: boolean
}

export const initialState: State = {
  managementReports: {},
  pending: true,
  error: false
}

export default (
  state = initialState,
  action: ManagementReportAction
): State => {
  switch (action.type) {
    case 'managementReports.fetch':
      return {
        ...state,
        pending: true,
        managementReports: {},
        error: false
      }
    case 'managementReports.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'managementReports.add':
      let item: ManagementReport = EmptyManagementReport

      if ('payload' in action) {
        item = action.payload ?? EmptyManagementReport
      }

      return {
        ...state,
        managementReports: addOrUpdateManagementReport(
          state.managementReports,
          item
        )
      }

    default:
      return state
  }
}
